import { enqueueSnackbar } from "notistack";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import CommonAlert from "@/components/CommonAlert";
import { useStopShiftMutation } from "@/requests/daily-status.queries";
import { useShiftShowCompleteShiftConfirmation } from "@/stores/use-shift";
import { DriverStatus } from "@/types/daily-status.types";

import { calculateDiff } from "../..";

function CompleteShift({
    handleClose,
    currentShift,
}: {
    handleClose: (request?: boolean) => void;
    currentShift: DriverStatus | undefined | false;
}) {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useStopShiftMutation();
    const isRequestingLocationRef = useRef<boolean>(false);
    const showCompleteShiftConfirmation = useShiftShowCompleteShiftConfirmation();

    const positionSuccessCb = async ({ coords }: GeolocationPosition) => {
        isRequestingLocationRef.current = false;
        if (isPending) return;
        try {
            const latitude = coords.latitude;
            const longitude = coords.longitude;
            if (!latitude || !longitude) {
                enqueueSnackbar(t(`GeolocationPositionError.1`), { variant: "error" });
                return;
            }
            await mutateAsync({ latitude, longitude });
            enqueueSnackbar("Mesainiz başarılı şekilde bitirildi.", { variant: "success" });
            handleClose(true);
        } catch (err) {
            console.error("positionSuccessCb error:", err);
        }
    };
    const diff = currentShift && calculateDiff(currentShift.startTime);

    const positionErrorCb = ({ code }: { code?: number; message: string }) => {
        isRequestingLocationRef.current = false;
        t(`GeolocationPositionError.${code ? code.toString() : "1"}`);
        enqueueSnackbar(t(`GeolocationPositionError.${code ? code.toString() : "1"}`), { variant: "error" });
    };

    const handleConfirm = async () => {
        if (isPending || isRequestingLocationRef.current) return;
        if (!("navigator" in window) || !("geolocation" in navigator)) {
            enqueueSnackbar(
                "Kullandığınız tarayıcı konum almayı desteklemiyor.Lütfen farklı bir tarayıcıdan tekrar deneyiniz.",
                { variant: "info" }
            );
            return;
        }
        // Lock to prevent multiple concurrent geolocation requests
        isRequestingLocationRef.current = true;
        navigator.geolocation.getCurrentPosition(positionSuccessCb, positionErrorCb);
    };

    if (!currentShift || !diff) return null;
    return (
        <CommonAlert
            open={showCompleteShiftConfirmation && !!diff}
            loading={isPending || isRequestingLocationRef.current}
            description="confirmations.endShift"
            color="primary"
            onClose={() => handleClose()}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                hours: (diff && diff[0]) || "",
                minutes: (diff && diff[1]) || "",
            }}
        />
    );
}

export default CompleteShift;
